import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InvestigationTable from "./InvestigationTable";
import CreateInvestigation from "./CreateInvestigation/CreateInvestigation";
import {
  getInvestigationById,
  getAllInvestigation,
  updateInvestigation,
  deleteInvestigation,
  clearSelectedInvestigation,
} from "../../store/action/investigation";
// We’ll no longer rely on investigation.css for layout if we move to makeStyles;
// but we can keep a short CSS file for minor overrides if needed.
import "./investigation.css";  

// Copy or adapt the styling approach from Sinistres:
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
}));

const Investigation = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const { investigationData, selectedInvestigation, loading } = useSelector(
    (state) => state.investigationReducer
  );

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("idInvestigation");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [showCreateInvestigation, setShowCreateInvestigation] = useState(false);
  const [readOnly, setReadOnly] = useState(false);

  useEffect(() => {
    dispatch(getAllInvestigation());
  }, [dispatch]);

  const handleAddInvestigation = () => {
    dispatch(clearSelectedInvestigation());
    setShowCreateInvestigation(true);
  };

  const handleBackInvestigation = () => {
    setShowCreateInvestigation(false);
  };

  const handleUpdateInvestigation = (id) => {
    const updatedInvestigation = { status: "Updated" };
    dispatch(updateInvestigation(id, updatedInvestigation));
  };

  const handleDeleteInvestigation = async (id) => {
    await dispatch(deleteInvestigation(id));
    dispatch(getAllInvestigation());
    setOpen(false);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleViewClick = (id) => {
    dispatch(getInvestigationById(id));
    setShowCreateInvestigation(true);
    setReadOnly(true);
  };

  const handleEditClick = (id) => {
    dispatch(getInvestigationById(id));
    setShowCreateInvestigation(true);
    setReadOnly(false);
  };

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={classes.root}>
      {showCreateInvestigation ? (
        <CreateInvestigation
          handleBackInvestigation={handleBackInvestigation}
          selectedInvestigation={selectedInvestigation}
          readOnly={readOnly}
          // Pass claimNumber if available
          selectedClaimNumber={selectedInvestigation?.claimNumber}
        />
      ) : (
        <Paper className={classes.paper}>
          <InvestigationTable
            investigationData={investigationData}
            loading={loading}
            order={order}
            orderBy={orderBy}
            page={page}
            rowsPerPage={rowsPerPage}
            handleRequestSort={handleRequestSort}
            handleViewClick={handleViewClick}
            handleEditClick={handleEditClick}
            handleDeleteClick={handleDeleteClick}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            open={open}
            handleClose={handleClose}
            selectedId={selectedId}
            handleDeleteInvestigation={handleDeleteInvestigation}
            handleAddInvestigation={handleAddInvestigation}
          />
        </Paper>
      )}
    </div>
  );
};

export default Investigation;
